import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ViewChildren, QueryList } from '@angular/core';
import * as _ from "lodash";

import * as ent from '../entities/index'

//components
import { MessageHandlerComponent } from '../components/Controls/MessageHandler.component';

//base
import { BaseDropdownComponent } from '../baseclasses/BaseDropdown.component';


export abstract class BaseDomainDataGridComponent implements OnInit{
    ngOnInit() {};

    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    
    handleResponse(response: ent.Response){
        
        this.messageHandlerComponent.handleResponse(response);
        
    }


}

export default BaseDomainDataGridComponent;